<div class="min-h-[calc(100vh-4.3rem)] relative">
  <div
    [ngClass]="{
      'pr-0 transition-all duration-300': !sidebarOpen && !isResizing,
      'transition-all duration-200': sidebarOpen && !isResizing,
    }"
    [style.padding-right.px]="sidebarOpen ? sidebarWidth : 0"
  >
    <div class="px-4 py-10 sm:px-6 lg:px-8 lg:py-6 relative h-[calc(100vh-4.3rem)]">
      <p class="text-amazone-green me-10 text-end">
        Found <strong>{{ itemsTotalCount }}</strong> Error Codes
      </p>
      <div class="relative">
        <app-error-code-table
          [recyclingModeEnabled]="recyclingModeEnabled"
          [errorCodes]="items"
          [selectedElementId]="$safeNavigationMigration(selectedItem?.id)"
          (searchTriggered)="onSearchTriggered($event)"
          (errorCodeClicked)="onItemClicked($event)"
          (scrolledToBottom)="onScrolledToTheBottom($event)"
          (sortByFieldChanged)="onSortByChanged($event)"
          (softDeleteErrorCode)="onSoftDeleteTriggered($event)"
          (hardDeleteErrorCode)="onHardDeleteTriggered($event)"
          (restoreErrorCode)="onRestoreTriggered($event)"
        ></app-error-code-table>
        <button
          [appEnabledByPolicy]="policy.canCreate"
          class="crud-btn-overview"
          (click)="createErrorCode()"
          appAgentAction
          agent="error-code-overview-create"
          businessObject="errorCode"
          action="create"
        >
          <app-add></app-add>
        </button>
      </div>
    </div>
  </div>

  @if (sidebarOpen) {
    <div
      class="right-0 fixed overflow-y-auto border-l border-gray-200 min-h-full top-[4rem]"
      [style.width.px]="sidebarWidth"
    >
      <div
        class="absolute left-0 top-0 w-1.5 h-full cursor-col-resize bg-transparent hover:bg-amazone-green hover:opacity-50 transition-colors duration-200"
        (mousedown)="startResize($event)"
      ></div>
      <app-sidebar
        [sideBarTitle]="sideBarTitle"
        [detailsViewConfig]="errorCodeDetailConfiguration"
        [sidebarConfiguration]="sidebarConfiguration"
        [editComponentId]="errorCodeEditComponentId"
        [editComponentType]="errorCodeEditComponent"
        [errorCode]="selectedItem"
        [detailedLanguageTranslationStatesDocumentation]="
          $safeNavigationMigration(selectedItem?.languageTranslationStatesDocumentation)
        "
        [detailedLanguageTranslationStatesTerminal]="
          $safeNavigationMigration(selectedItem?.languageTranslationStatesTerminal)
        "
        (closeSidebarTriggered)="onClosingSidebar()"
        (updatedErrorCode)="onUpdatedErrorCode($event)"
      ></app-sidebar>
    </div>
  }
</div>
